import { Button, Center, Text } from "@chakra-ui/react";
import { ModalDrawer, CloseIcon } from "dapp-sdk-v2";

export interface DefiDataProps {
  title: string;
  subTitle?: string;
  ctaLabel?: string;
  ctaAction?: () => void;
}

interface DefiModalProps {
  isOpen: boolean;
  data?: DefiDataProps | null;
  closeAlert: () => void;
}

export const DefiModal = ({ isOpen, data, closeAlert }: DefiModalProps) => {
  return (
    <ModalDrawer isOpen={isOpen} closeAlert={closeAlert}>
      <Center
        padding={{ base: "0 1rem 2.5rem", md: "2.5rem 3rem" }}
        fontWeight="600"
        flexDirection="column"
        width="100%"
      >
        {
          <>
            <CloseIcon onClose={closeAlert} />
            {data && (
              <Center flexDirection="column" gap="0.5rem">
                <Text fontSize={{ base: "16px", lg: "24px" }}>
                  {data.title}
                </Text>
                {data.subTitle && (
                  <Text
                    fontWeight="400"
                    max-width={{ base: "100%", lg: "360px" }}
                    textAlign="center"
                    fontSize={{ base: "12px", lg: "14px" }}
                    color="textSecondary"
                  >
                    {data.subTitle}
                  </Text>
                )}
                {data.ctaLabel && (
                  <Button
                    mt="20px"
                    onClick={data.ctaAction ? data.ctaAction : closeAlert}
                  >
                    {data.ctaLabel}
                  </Button>
                )}
              </Center>
            )}
          </>
        }
      </Center>
    </ModalDrawer>
  );
};
